var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAddImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.896 30.896",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M475.426,1261.418a1.545,1.545,0,0,0-1.545,1.545v5.221l-2.286-2.286a4.311,4.311,0,0,0-6.071,0l-1.081,1.1-3.831-3.846a4.31,4.31,0,0,0-6.071,0l-2.286,2.3v-8.666a1.545,1.545,0,0,1,1.545-1.545h12.358a1.545,1.545,0,1,0,0-3.09H453.8a4.635,4.635,0,0,0-4.634,4.635v18.877a4.31,4.31,0,0,0,4.295,4.294h19.217a4.4,4.4,0,0,0,1.236-.186h0a4.229,4.229,0,0,0,3.09-4.094v-12.714a1.544,1.544,0,0,0-1.543-1.545ZM453.8,1276.866a1.544,1.544,0,0,1-1.545-1.545v-5.515l4.464-4.464a1.207,1.207,0,0,1,1.7,0l11.54,11.524Zm20.082-1.545a1.535,1.535,0,0,1-.278.834l-6.983-7.013,1.1-1.082a1.191,1.191,0,0,1,1.682-.017l.017.017,4.464,4.5Zm4.634-23.172h-1.545V1250.6a1.545,1.545,0,1,0-3.09,0v1.545h-1.545a1.545,1.545,0,1,0,0,3.09h1.545v1.545a1.545,1.545,0,0,0,3.09,0v-1.545h1.545a1.545,1.545,0,1,0,0-3.09Z",
    transform: "translate(-449.164 -1249.06)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddImage);
export default __webpack_public_path__ + "static/media/icon-add-image.c84fa38a.svg";
export { ForwardRef as ReactComponent };